const CaseStatusEnum = {
  OPEN: "OPEN",
  CLOSED: "CLOSED",
  DRAFT: "DRAFT",
};

export default CaseStatusEnum;
